import { ReadonlyURLSearchParams } from 'next/navigation';

export const getAgeMax = (searchParams: ReadonlyURLSearchParams) => Number(searchParams.get('ageRangeEnd'));
